export default {
  transactionCodeResults: [],
};
